import React from 'react';
import { Box, Typography, Grid, Card, CardContent, CardActionArea } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import KeyIcon from '@mui/icons-material/Key';
import RouterIcon from '@mui/icons-material/Router';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import MapIcon from '@mui/icons-material/Map';

// Smaller glyph on phones, where the circle behind it shrinks too.
const ICON_SIZE = { xs: 30, sm: 48 };

const menuItems = [
  {
    label: 'Machines',
    icon: <PrecisionManufacturingIcon sx={{ fontSize: ICON_SIZE }} />,
    path: '/equipment/machines',
    color: '#003A70',
  },
  {
    label: 'GPS Licenses',
    icon: <KeyIcon sx={{ fontSize: ICON_SIZE }} />,
    path: '/equipment/gps-licenses',
    color: '#DA1C3C',
  },
  {
    label: 'GPS Systems',
    icon: <GpsFixedIcon sx={{ fontSize: ICON_SIZE }} />,
    path: '/equipment/machines/gps-health',
    color: '#0ea5e9',
  },
  {
    label: 'Omnibox',
    icon: <RouterIcon sx={{ fontSize: ICON_SIZE }} />,
    path: '/equipment/omnibox',
    color: '#1a7f4b',
  },
  {
    label: 'GPS Rovers',
    icon: <SettingsInputAntennaIcon sx={{ fontSize: ICON_SIZE }} />,
    path: '/equipment/gps-rovers',
    color: '#7c3aed',
  },
  {
    label: 'Load Testing',
    icon: <FlashOnIcon sx={{ fontSize: ICON_SIZE }} />,
    path: '/equipment/data-loggers',
    color: '#d97706',
  },
  {
    label: 'Equipment Map',
    icon: <MapIcon sx={{ fontSize: ICON_SIZE }} />,
    path: '/equipment/map',
    color: '#0f766e',
  },
];

function LandingPage() {
  const navigate = useNavigate();

  return (
    <Box>
      <Grid container spacing={{ xs: 1.5, sm: 3 }}>
        {menuItems.map((item) => (
          <Grid item xs={6} sm={6} md={4} key={item.label}>
            <Card
              sx={{
                height: '100%',
                boxShadow: '0 4px 20px rgba(255, 255, 255, 0.15)',
                transition: 'all 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 30px rgba(255, 255, 255, 0.25)',
                },
              }}
            >
              <CardActionArea
                onClick={() => navigate(item.path)}
                sx={{ height: '100%', p: { xs: 1, sm: 2 } }}
              >
                <CardContent sx={{ textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                  <Box
                    sx={{
                      width: { xs: 56, sm: 80 },
                      height: { xs: 56, sm: 80 },
                      borderRadius: '50%',
                      backgroundColor: item.color,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mx: 'auto',
                      mb: 2,
                      color: 'white',
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Typography variant="h6" fontWeight={700} sx={{ mb: 1, fontSize: { xs: '0.95rem', sm: '1.25rem' } }}>
                    {item.label}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default LandingPage;
